<template>
    <div>
        <div id="baiduMap" ref="baiduMap"></div>
        <z-locus></z-locus>
        <z-details-drawer></z-details-drawer>
    </div>
</template>
<script>
    import ZLocus from './Locus.vue'
    import ZDetailsDrawer from './DetailsDrawer.vue'

    import BMap from 'BMap'
    import BMapLib from 'BMapLib'
    import INFOBOX_AT_TOP from 'INFOBOX_AT_TOP'
    import BMAP_ANCHOR_BOTTOM_RIGHT from 'BMAP_ANCHOR_BOTTOM_RIGHT'
    import BMAP_NAVIGATION_CONTROL_ZOOM from 'BMAP_NAVIGATION_CONTROL_ZOOM'
    import BMAP_MAPTYPE_CONTROL_MAP from 'BMAP_MAPTYPE_CONTROL_MAP'

    import iconNormalImg from '../../assets/point_normal_icon.png'
    // import iconwarningImg from '../../assets/point_warning_icon.png'
    import closeImg from '../../assets/point_close.png'
    
    let infoBoxTemp = null;

    export default {
        name: 'ZBaiduMap',
        data() {
            return {
               
            }
        },
        components: {
            ZLocus,
            ZDetailsDrawer
        },
        methods: {
            baiduMap(){
                let map = new BMap.Map(this.$refs.baiduMap, { enableAutoResize: false, enableMapClick: false });
                map.centerAndZoom(new BMap.Point(116.404,39.915),12);
                map.enableScrollWheelZoom(true);   

                /* 缩放 */
                let top_right_navigation = new BMap.NavigationControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT, type: BMAP_NAVIGATION_CONTROL_ZOOM, offset: new BMap.Size(22,90), showZoomInfo:true});
                    map.addControl(top_right_navigation);
                /* 地图类型 */
                let map_type = new BMap.MapTypeControl({type:BMAP_MAPTYPE_CONTROL_MAP});    
                    map.addControl(map_type);
                    map_type.setAnchor(BMAP_ANCHOR_BOTTOM_RIGHT);
                    map_type.setOffset(new BMap.Size(18,20)); 
                /* 定位 */
                let pos_opts = {anchor:BMAP_ANCHOR_BOTTOM_RIGHT,type:BMAP_NAVIGATION_CONTROL_ZOOM, offset: new BMap.Size(22,178)};
                    map.addControl(new BMap.GeolocationControl(pos_opts));

                //删除对应覆盖物
                let allOverlay = map.getOverlays();
                for (let j = 0; j < allOverlay.length; j++) {
                   if (allOverlay[j].CarID == 13600) {
                       map.removeOverlay(allOverlay[j]);
                   }
                }

                let point = new BMap.Point(116.312237, 39.914333);
                let iocUrl = new BMap.Icon(iconNormalImg, new BMap.Size(29, 30), {
                    anchor: new BMap.Size(10, 30)
                });
                // let iocUrl = new BMap.Icon(iconwarningImg, new BMap.Size(29, 30), {
                //     anchor: new BMap.Size(10, 30)
                // });
                let marker = new BMap.Marker(point, { icon: iocUrl });
                marker.CarID = 13660;
                marker.addEventListener("click", function () {
                    let _this = this;
                    let clickCarID = _this.CarID;
                    baiduMapMarkerOpen(map,clickCarID);
                });
                map.addOverlay(marker);
            }
        },        
        mounted(){
            this.baiduMap()
        }
    } 
    function baiduMapMarkerOpen(map,carid){
        let point = new BMap.Point(116.312237, 39.914333);    
        baiduMapMarkerInfo(map);
        let marker = {};
        let allOverlay = map.getOverlays();        
        for (let j=0;j<allOverlay.length;j++) {            
            if (allOverlay[j].CarID == carid) {
                marker = allOverlay[j];
            }
        }
        map.centerAndZoom(point, map.getZoom());
        infoBoxTemp.open(marker);
    }
    function baiduMapMarkerInfo(map) {
        let info_html = [];
        info_html.push("<div class='point-content'>");
        info_html.push("<div class='point-top'>");
        info_html.push("<div class='pointInfo-content'>");
        info_html.push("<ul><li>");
        info_html.push("<span class='point-name'>刘三姐</span>");
        info_html.push("<i>-</i>");
        info_html.push("<span class='point-group'>分组</span>");
        info_html.push("<i>-</i>");
        info_html.push("<span class='point-remark'>备注</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>状态：</label><span>在线</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>是否告警：</label><span>否</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>位置：</label><span>翠海明苑16号2单元</span>");
        info_html.push("<a href='javascript:;' class='positionImg'></a>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>定位类型：</label>");
        info_html.push("<span class='posType posTypeOne'></span>");
        info_html.push("<span class='posType posTypeTwo'></span>");
        info_html.push("<span class='posType posTypeThree'></span>");
        info_html.push("<span class='posType posTypeFour'></span>");
        info_html.push("<span class='posType posTypefive'></span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>时间：</label><span>2019/01/18 16:10</span>");
        info_html.push("</li></ul>");
        info_html.push("<div class='pointInfo-two-content'>");
        info_html.push("<ul class='clearfix'>");
        info_html.push("<li>");
        info_html.push("<label>电量：</label>");
        info_html.push("<span>100%</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>步数：</label>");
        info_html.push("<span>1000步</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>心率：</label>");
        info_html.push("<span>60次/分</span>");
        info_html.push("<span class='heartImg'></span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<label>是否绑表：</label>");
        info_html.push("<span>是</span>");
        info_html.push("</li>");
        info_html.push("<li>");
        info_html.push("<li>");
        info_html.push("<label>设备型号：</label>");
        info_html.push("<span>Z50</span>");
        info_html.push("<span class='deviceModelImg'></span>");
        info_html.push("</li>");        
        info_html.push("</ul>");
        info_html.push("</div>");
        info_html.push("</div>");
        info_html.push("</div>");
        info_html.push("<div class='point-bottom'>");
        info_html.push("<ul>");
        info_html.push("<li><a href='javascript:;' onclick='userDetailsByCarid()'>详情</a></li>");
        info_html.push("<li><a href='javascript:;' onclick='LocusByCarid()'>轨迹/追踪</a></li>");
        info_html.push("<li><a href='javascript:;' onclick='userDetailsByCarid()'>健康</a></li>");
        info_html.push("<li><a href='javascript:;' onclick='userDetailsByCarid()'>告警</a></li>");
        info_html.push("</ul>"); 
        info_html.push("</div>");
        info_html.push("</div>");
        info_html.push("<div class='point-arrow'></div>");
        let infoBox = new BMapLib.InfoBox(map, info_html.join(""), {
            boxStyle: {
                width: "300px",
                height: "auto"
            },
            offset: new BMap.Size(0, 40),
            closeIconMargin: "13px 13px 0 0",            
            closeIconUrl: closeImg,
            enableAutoPan: true,
            align: INFOBOX_AT_TOP
        });
        if (infoBoxTemp) {
            infoBoxTemp.close();
        }
        infoBoxTemp = infoBox;
    }
</script>